/**
 * Created by guyavarham on 17/07/2017.
 */

const isMobile = state => state.browser.lessThan.small; // will catch only phones
const isMobileOrTablet = state => state.browser.lessThan.large || state.platform.isMobilePlatform;
const isLocalStorageAccessible = state => state.platform.isLocalStorageAccessible;

export { isMobile, isMobileOrTablet, isLocalStorageAccessible };
